import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import BreadCrumbs from "../components/page/BreadCrumbs";
import HtmlHelmet from "../components/common/HtmlHelmet";

const MicrositeProgress = () => {
  const statusRef = useRef(null);
  const [orderId, setOrderId] = useState("");
  const [decryptedToken, setDecryptedToken] = useState("");

  const micrositeActionUrl = `${process.env.REACT_APP_LIC_MICROSITE_URL}/transaction-complete`;

  const payload = useMemo(
    () => ({
      fullName: "Mahdi Ibne Javed",
      mobile: "01712555327",
      billType: "NEW-POLICY",
      amount: "25,144.00",
      currency: "BDT",
    }),
    []
  );

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const orderIdFromUrl = params.get("order_id") || "";
    const sslTokenFromUrl = params.get("ssl_token") || "";
    setOrderId(orderIdFromUrl);

    if (orderIdFromUrl) localStorage.setItem("lic_microsite_order_id", orderIdFromUrl);

    const run = async () => {
      try {
        if (!sslTokenFromUrl) {
          setDecryptedToken("");
          return;
        }
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/decryptMicrositePayload`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ payload: sslTokenFromUrl }),
          }
        );
        const data = await res.json();
        const plain = data?.plain || "";
        setDecryptedToken(plain);
        if (plain) localStorage.setItem("lic_microsite_token", plain);
      } catch (e) {
        setDecryptedToken("");
      }
    };

    run();
  }, []);

  const meta_data = {
    meta_title: "Opening LIC Microsite",
    meta_description: "Please wait while we open the LIC microsite",
    meta_keywords: "lic, microsite, bill",
  };

  const bread_cumbs = [
    {
      bn_title: "এলআইসি মাইক্রোসাইট",
      title: "LIC Microsite",
      url: "/microsite-progress",
    },
    {
      bn_title: "হোম",
      title: "Home",
      url: "/",
    },
  ];

  return (
    <Fragment>
      <HtmlHelmet custom_meta={meta_data} />
      <BreadCrumbs bread_curmbs={bread_cumbs} />

      <section style={{ padding: "40px 0" }}>
        <div className="container">
          <div
            className="card shadow-sm"
            style={{ maxWidth: 720, margin: "0 auto" }}
          >
            <div className="card-body" style={{ padding: 28 }}>
              <form action={micrositeActionUrl} method="POST">
                <input type="hidden" name="fullName" value={payload.fullName} />
                <input type="hidden" name="mobile" value={payload.mobile} />
                <input type="hidden" name="order_id" value={orderId} />
                <input
                  type="hidden"
                  name="bank_transaction_id"
                  value={orderId}
                />
                <input type="hidden" name="token" value={decryptedToken} />
                <input type="hidden" name="billType" value={payload.billType} />
                <input type="hidden" name="amount" value={payload.amount} />
                <input type="hidden" name="currency" value={payload.currency} />
                <input
                  ref={statusRef}
                  type="hidden"
                  name="transaction_status"
                  value="SUCCESS"
                />

                <div>
                  <h4 style={{ margin: 0 }}>Microsite progress</h4>
                  <div style={{ marginTop: 6, color: "#6c757d" }}>
                    Review the details below, then confirm.
                  </div>
                </div>

                <hr />

                <div className="table-responsive">
                  <table className="table table-sm table-bordered mb-0">
                    <tbody>
                      <tr>
                        <th style={{ width: 220 }}>Full name</th>
                        <td>{payload.fullName}</td>
                      </tr>
                      <tr>
                        <th>Mobile</th>
                        <td>{payload.mobile}</td>
                      </tr>
                      <tr>
                        <th>Order ID</th>
                        <td>{orderId || "-"}</td>
                      </tr>
                      <tr>
                        <th>Bill type</th>
                        <td>{payload.billType}</td>
                      </tr>
                      <tr>
                        <th>Amount</th>
                        <td>
                          {payload.currency} {payload.amount}
                        </td>
                      </tr>
                      <tr>
                        <th>Transaction status</th>
                        <td>SUCCESS / CANCELLED</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                    marginTop: 18,
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={(e) => {
                      e.preventDefault();
                      if (statusRef.current) statusRef.current.value = "CANCELLED";
                      e.currentTarget.form?.submit();
                    }}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Confirm
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default MicrositeProgress;
